(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2190],{

/***/ 4083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(67294);

function ArrowLongLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a.75.75 0 01-.75.75H4.66l2.1 1.95a.75.75 0 11-1.02 1.1l-3.5-3.25a.75.75 0 010-1.1l3.5-3.25a.75.75 0 111.02 1.1l-2.1 1.95h12.59A.75.75 0 0118 10z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 33636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(67294);

function ArrowLongRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowLongRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 56438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const SeoHead = (props)=>{
    const { seo  } = props;
    const { canonicalUrl  } = seo;
    const twitter = seo.socials.find((social)=>social.network === "twitter");
    const facebook = seo.socials.find((social)=>social.network === "facebook");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            facebook && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: facebook.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: facebook.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: seo.canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(facebook.image.data.attributes.url)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Codealo"
                    })
                ]
            }),
            twitter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: twitter.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: twitter.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(twitter.image.data.attributes.url)
                    })
                ]
            }),
            canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: seo.robots
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 13476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const getColor = (color)=>{
    switch(color){
        case "yellow":
            return "bg-yellow-100 text-yellow-800";
        case "red":
            return "bg-red-100 text-red-800";
        case "green":
            return "bg-green-100 text-green-800";
        case "blue":
            return "bg-blue-100 text-blue-800";
        case "indigo":
            return "bg-indigo-100 text-indigo-800";
        case "purple":
            return "bg-purple-100 text-purple-800";
        case "pink":
            return "bg-pink-100 text-pink-800";
        default:
            return "bg-gray-100 text-gray-800";
    }
};
const Tag = (param)=>{
    let { type , color  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "inline-flex items-center rounded-xl px-2 py-0.5 text-xs font-semibold ".concat(getColor(color)),
            children: type
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tag);


/***/ }),

/***/ 60699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms_SeoHead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56438);
/* harmony import */ var _organisms_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35604);
/* harmony import */ var _organisms_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58620);





const DefaultLayout = (param)=>{
    let { seo , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_SeoHead__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                seo: seo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex min-h-screen flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                        className: "flex-1",
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);


/***/ }),

/***/ 64798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const PageHeading = (param)=>/*#__PURE__*/ {
    let { title , description  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mb-5 pb-5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight",
                children: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-2 max-w-4xl text-sm text-gray-500",
                children: description
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeading);


/***/ }),

/***/ 71742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4083);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33636);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_contexts_PaginationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83435);





const Pagination = ()=>{
    const { pagination , onNext , onBack , onSetPage  } = (0,src_contexts_PaginationContext__WEBPACK_IMPORTED_MODULE_3__/* .usePagination */ .h)();
    const { page , pageCount  } = pagination;
    const onClickPage = (e, value)=>{
        e.preventDefault();
        onSetPage(value);
    };
    const next = (e)=>{
        e.preventDefault();
        onNext();
    };
    const back = (e)=>{
        e.preventDefault();
        onBack();
    };
    if (pageCount === 1) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        className: "flex items-center justify-between border-t border-gray-200 px-4 sm:px-0",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "-mt-px flex w-0 flex-1",
                children: page > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: "#",
                    className: "inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700",
                    onClick: back,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_4__, {
                            className: "mr-3 h-5 w-5 text-gray-400",
                            "aria-hidden": "true"
                        }),
                        "Atras"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden md:-mt-px md:flex",
                children: Array.from(Array(pageCount).keys()).map((entry, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "#",
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700", {
                            "border-primary text-indigo-600": entry + 1 === page
                        }),
                        onClick: (e)=>onClickPage(e, entry + 1),
                        children: entry + 1
                    }, entry))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "-mt-px flex w-0 flex-1 justify-end",
                children: page < pageCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: "#",
                    className: "inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700",
                    onClick: next,
                    children: [
                        "Siguiente",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_5__, {
                            className: "ml-3 h-5 w-5 text-gray-400",
                            "aria-hidden": "true"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 83435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ PaginationProvider; },
  "h": function() { return /* binding */ usePagination; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
;// CONCATENATED MODULE: ./src/hooks/usePaginatedContent.tsx


const usePaginatedContent = (param)=>{
    let { queryKey , queryFunction , initialData  } = param;
    const [pagination, setPagination] = (0,react.useState)({
        page: 1,
        pageSize: 10,
        pageCount: 1,
        total: 0
    });
    const sort = [
        "createdAt:desc"
    ];
    const { isSuccess , data: responseData , isLoading , isError , isFetching  } = (0,useQuery/* useQuery */.a)([
        queryKey,
        pagination,
        sort
    ], ()=>queryFunction({
            key: queryKey,
            pagination,
            sort
        }), {
        initialData
    });
    const onNext = ()=>{
        if (responseData) {
            const { page , pageCount  } = responseData.meta.pagination;
            setPagination({
                ...pagination,
                page: Math.min(page + 1, pageCount)
            });
            scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    };
    const onBack = ()=>{
        const { page  } = pagination;
        setPagination({
            ...pagination,
            page: Math.max(page - 1, 1)
        });
        scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const onSetPage = (value)=>{
        setPagination({
            ...pagination,
            page: value
        });
        scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(()=>{
        if (responseData) {
            const { pagination  } = responseData.meta;
            setPagination({
                ...pagination,
                pageCount: pagination.pageCount,
                total: pagination.total
            });
        }
    }, [
        responseData
    ]);
    return {
        isSuccess,
        isLoading,
        isError,
        isFetching,
        data: (responseData === null || responseData === void 0 ? void 0 : responseData.data) || [],
        pagination,
        onNext,
        onBack,
        onSetPage
    };
};
/* harmony default export */ var hooks_usePaginatedContent = (usePaginatedContent);

;// CONCATENATED MODULE: ./src/contexts/PaginationContext.tsx



const PaginationContext = /*#__PURE__*/ (0,react.createContext)({
    isSuccess: false,
    isLoading: false,
    isError: false,
    isFetching: false,
    pagination: {
        page: 1,
        pageCount: 1,
        pageSize: 10,
        total: 0
    },
    data: [],
    onNext: ()=>null,
    onBack: ()=>null,
    onSetPage: ()=>null
});
const PaginationProvider = (param)=>{
    let { initialData , queryFunction , queryKey , children  } = param;
    const value = hooks_usePaginatedContent({
        queryFunction,
        queryKey,
        initialData
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationContext.Provider, {
        value: value,
        children: children
    });
};
const usePagination = ()=>{
    return (0,react.useContext)(PaginationContext);
};



/***/ }),

/***/ 82829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u3": function() { return /* binding */ getBlogPosts; },
  "bj": function() { return /* binding */ getContentTypeBySlug; },
  "Ho": function() { return /* binding */ getCourses; },
  "VI": function() { return /* binding */ getExercises; },
  "_5": function() { return /* binding */ runCode; }
});

// UNUSED EXPORTS: findByExerciseIdAndUserId, getBlogPostBySlug, getExerciseBySlug, getMarketingPageBySlug, getProgrammingLanguages, getSlugsForContentType, getSolutionById, getSolutionsByExerciseId

;// CONCATENATED MODULE: ./src/types/ContentTypes/index.ts
var ContentTypes_ContentTypes;
(function(ContentTypes) {
    ContentTypes["BLOG_POSTS"] = "blog-posts";
    ContentTypes["CODE_EXERCISES"] = "code-exercises";
    ContentTypes["COURSES"] = "courses";
    ContentTypes["MARKETING_PAGE"] = "marketing-page";
    ContentTypes["EXERCISE_SOLUTION"] = "exercise-solutions";
})(ContentTypes_ContentTypes || (ContentTypes_ContentTypes = {}));

// EXTERNAL MODULE: ./src/utils/stringUtils.ts
var stringUtils = __webpack_require__(53618);
// EXTERNAL MODULE: ./src/services/fetchers.ts
var fetchers = __webpack_require__(23908);
;// CONCATENATED MODULE: ./src/services/DefaultService.ts
/* provided dependency */ var process = __webpack_require__(83454);




const getHeader = ()=>{
    const currentUser = localStorage.getItem(process.env.NEXT_PUBLIC_USER_KEY || "");
    if (!currentUser) throw new Error("User not authenticated");
    return {
        Authorization: "Bearer ".concat(currentUser)
    };
};
async function getProgrammingLanguages() {
    const { data  } = await axiosCMS.get("/api/programming-languages", {
        params: {
            fields: [
                "name",
                "codeHighlightName",
                "enabled"
            ],
            filters: {
                enabled: {
                    $eq: true
                }
            }
        }
    });
    return data;
}
async function getExercises(param) {
    let { key , pagination , sort  } = param;
    const { data  } = await fetchers/* axiosCMS.get */.Y.get("/api/code-exercises", {
        params: {
            pagination,
            sort,
            populate: [
                "techStack"
            ]
        }
    });
    return data;
}
async function getBlogPosts(param) {
    let { key , pagination , sort  } = param;
    const { data  } = await fetchers/* axiosCMS.get */.Y.get("/api/blog-posts", {
        params: {
            pagination,
            sort,
            populate: {
                author: {
                    fields: [
                        "firstName",
                        "lastName",
                        "username"
                    ],
                    populate: [
                        "profilePhoto"
                    ]
                },
                image: {
                    fields: "*"
                }
            }
        }
    });
    return data;
}
async function getCourses(param) {
    let { key , pagination , sort  } = param;
    const { data  } = await fetchers/* axiosCMS.get */.Y.get("/api/courses", {
        params: {
            pagination,
            sort,
            populate: {
                image: "*"
            }
        }
    });
    return data;
}
async function getContentTypeBySlug(param) {
    let { contentType , slug , populate =[]  } = param;
    const response = await fetchers/* axiosCMS.get */.Y.get("api/slugify/slugs/".concat(contentType, "/").concat(slug), {
        params: {
            populate: [
                "seo",
                "seo.socials",
                "seo.image",
                "seo.socials.image",
                ...populate
            ]
        }
    });
    return response.data;
}
async function getBlogPostBySlug(param) {
    let { slug  } = param;
    const response = await axiosCMS.get("api/slugify/slugs/blog-post/".concat(slug), {
        params: {
            populate: [
                "seo",
                "seo.socials",
                "seo.image",
                "seo.socials.image"
            ]
        }
    });
    return response.data;
}
async function getMarketingPageBySlug(param) {
    let { slug  } = param;
    const response = await axiosCMS.get("api/slugify/slugs/marketing-page/".concat(slug), {
        params: {
            populate: {
                content: {
                    on: {
                        "page.features": {
                            populate: [
                                "features",
                                "features.media"
                            ]
                        },
                        "shared.hero": {
                            populate: "*"
                        },
                        "shared.section-title": {
                            populate: "*"
                        }
                    }
                },
                seo: {
                    populate: [
                        "socials",
                        "socials.image",
                        "image"
                    ]
                }
            }
        }
    });
    return response.data.data;
}
async function getExerciseBySlug(param) {
    let { slug  } = param;
    const response = await axiosCMS.get("api/slugify/slugs/code-exercise/".concat(slug), {
        params: {
            populate: [
                "seo",
                "seo.socials",
                "seo.image",
                "seo.socials.image",
                "prompts",
                "prompts.programmingLanguage",
                "users"
            ]
        }
    });
    return response.data;
}
async function getSolutionById(param) {
    let { id  } = param;
    const response = await axiosCMS.get("api/exercise-solutions/".concat(id));
    return response === null || response === void 0 ? void 0 : response.data;
}
async function findByExerciseIdAndUserId(param) {
    let { exerciseId  } = param;
    const response = await axios.get("".concat("https://codealo-v2-dev-cms.onrender.com/", "/api/exercise-solutions/exercise"), {
        headers: getHeader()
    });
    return response;
}
async function runCode(param) {
    let { id , context , code , languageId , meta  } = param;
    const encoder = new TextEncoder();
    const toEncode = encoder.encode(code);
    // @ts-ignore
    const sourceCode = btoa(String.fromCharCode(...new Uint8Array(toEncode)));
    const { data  } = await fetchers/* axiosCMS.post */.Y.post("/api/code-runner/run", {
        sourceCode: (0,stringUtils/* encode */.cv)(code || ""),
        languageId,
        id,
        context,
        meta
    });
    return data;
}
async function getSlugsForContentType(type) {
    try {
        const response = await axiosCMS.get("api/".concat(type, "/slugs"));
        return response.data.data.map((entry)=>entry.slug);
    } catch (err) {
        return [];
    }
}
async function getSolutionsByExerciseId(exercise) {
    try {
        const response = await axiosCMS.get("api/".concat(ContentTypes.EXERCISE_SOLUTION, "/exercise?exerciseId=").concat(exercise));
        return response.data;
    } catch (err) {
        return [];
    }
}


/***/ }),

/***/ 53618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jx": function() { return /* binding */ decode; },
/* harmony export */   "cv": function() { return /* binding */ encode; },
/* harmony export */   "kC": function() { return /* binding */ capitalize; }
/* harmony export */ });
const capitalize = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
function encode(str) {
    return btoa(unescape(encodeURIComponent(str || "")));
}
function decode(bytes) {
    var escaped = escape(atob(bytes || ""));
    try {
        return decodeURIComponent(escaped);
    } catch (e) {
        return unescape(escaped);
    }
}


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

}]);